var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStageStreaming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stage-streaming__a",
    d: "M1.914 11.769c.762 0 1.379.618 1.378 1.38-.002 2.506.97 4.86 2.74 6.63 1.77 1.77 4.124 2.743 6.63 2.74.762 0 1.38.616 1.381 1.378 0 .371-.147.72-.404.977-.257.256-.604.403-.974.404-3.243.003-6.292-1.258-8.583-3.549-2.29-2.291-3.551-5.34-3.548-8.583 0-.72.552-1.31 1.255-1.372l.125-.005zm4.233.554c.762 0 1.379.619 1.379 1.38-.002 1.227.474 2.377 1.34 3.243.865.866 2.016 1.341 3.242 1.34.761 0 1.38.616 1.38 1.378 0 .37-.147.72-.404.976-.256.257-.603.404-.974.405-1.962.001-3.808-.762-5.195-2.149-1.387-1.386-2.15-3.232-2.148-5.195 0-.72.552-1.31 1.255-1.372l.125-.006zm6.534-1.836c1.461-.002 2.645 1.182 2.644 2.644-.002 1.461-1.187 2.647-2.649 2.648-1.461.002-2.645-1.182-2.644-2.644.002-1.41 1.104-2.562 2.493-2.644l.156-.004zm.007-9.494C15.93.989 18.98 2.25 21.27 4.54c2.29 2.291 3.551 5.34 3.548 8.583 0 .37-.147.717-.404.974s-.606.404-.976.404c-.762-.001-1.379-.619-1.378-1.38.002-2.507-.97-4.86-2.74-6.63-1.77-1.77-4.124-2.743-6.63-2.741-.762 0-1.38-.616-1.381-1.378 0-.72.55-1.31 1.252-1.375l.126-.005zm.555 4.233c1.962-.002 3.808.76 5.195 2.148 1.387 1.387 2.15 3.232 2.148 5.195 0 .37-.147.717-.404.974s-.606.404-.977.404c-.761 0-1.378-.619-1.378-1.38.002-1.226-.474-2.377-1.34-3.243-.865-.865-2.016-1.341-3.242-1.34-.762 0-1.38-.616-1.38-1.378-.001-.72.55-1.31 1.252-1.375l.126-.005z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(2.46 2.85)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stage-streaming__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stage-streaming__a"
  })), /*#__PURE__*/React.createElement("use", {
    fillRule: "nonzero",
    xlinkHref: "#stage-streaming__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 -2H27.353V28.27H-2z",
    mask: "url(#stage-streaming__b)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStageStreaming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stage-streaming.2bc90cb36c7b809af83b147ef96d901f.svg";